import React, { useState } from "react";
import Popup from "reactjs-popup";
import { Button, Form } from "react-bootstrap";
import "../styles/PopUps.css";

const PaymentMethodPopUp = ({
    setIsOpen,
    onProceed,
    onCancel,
    mode = "warning", // "warning" (US) or "select" (EMEA+)
    currentMethod,
}) => {
    const [open, setOpen] = useState(true);
    const [selectedMethod, setSelectedMethod] = useState(currentMethod || "ACH");

    const closeModal = () => {
        setOpen(false);
        setIsOpen(false);
    };

    const handleProceed = () => {
        if (mode === "select") {
            const paymentChanged = selectedMethod !== currentMethod;
            onProceed(paymentChanged); // Pass boolean
        } else {
            onProceed();
        }
        closeModal();
    };

    const handleCancel = () => {
        if (onCancel) onCancel();
        closeModal();
    };

    return (
        <div>
            <Popup open={open} closeOnDocumentClick={false}>
                <div className="warning-popup-area">
                    {mode === "warning" ? (
                        <>
                            <h4 className="payment-warning-header">Payment Method Changed</h4>
                            <div className="warning-radio-labels" style={{ marginBottom: "20px" }}>
                                <span>
                                    The payment method for this supplier has changed since the Update Bank request was submitted.<br />
                                    Do you want to proceed with Approval?
                                </span>
                            </div>
                        </>
                    ) : (
                        <>
                            <h4 className="payment-warning-header">Payment Method</h4>
                            <div className="warning-radio-labels" style={{ marginBottom: "20px" }}>
                                    <span>
                                        <strong>
                                            Select payment method for this bank. Current method is selected.
                                        </strong>
                                    </span>

                            </div>
                                <Form>
                                    <div style={{ paddingLeft: "80px", display: "flex", gap: "4rem" }}>
                                        <Form.Check
                                            type="radio"
                                            id="ach"
                                            label="ACH"
                                            name="paymentMethod"
                                            value="ACH"
                                            checked={selectedMethod === "ACH"}
                                            onChange={() => setSelectedMethod("ACH")}
                                        />
                                        <Form.Check
                                            type="radio"
                                            id="wir"
                                            label="WIR"
                                            name="paymentMethod"
                                            value="WIR"
                                            checked={selectedMethod === "WIR"}
                                            onChange={() => setSelectedMethod("WIR")}
                                        />
                                    </div>
                                </Form>

                        </>
                    )}
                    <div className="warning-buttons-container">
                        {mode === "warning" ? (
                            <>
                                <Button variant="primary" className="warning-buttons" onClick={handleCancel}>
                                    No
                                </Button>
                                <Button variant="primary" className="warning-buttons" onClick={handleProceed}>
                                    Yes
                                </Button>
                            </>
                        ) : (
                            <>
                                    <Button variant="primary" className="payment-method-change-buttons" onClick={handleCancel}>
                                    Cancel
                                </Button>
                                    <Button variant="primary" className="payment-method-change-buttons" onClick={handleProceed}>
                                    Submit
                                </Button>
                            </>
                        )}
                    </div>

                </div>
            </Popup>
        </div>
    );
};

export default PaymentMethodPopUp;
